import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import { LoginRoute, PrivateRoute } from "./utils/RouteUtils";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Landing from "./pages/Landing";
import Search from "./pages/Search";
import Login from "./pages/Login";
import Edit from "./pages/Edit";
import User from "./pages/User";
import ChangePassword from "./pages/ChangePassword";
import ForgotPassword from "./pages/ForgotPassword";
import DeleteUser from "./pages/DeleteUser";

const Routes = () => {
  return (
    <div>
      <Navbar />
      <Switch>
        <PrivateRoute path="/edit" exact component={Edit} />
        <PrivateRoute path="/search" exact component={Search} />
        <PrivateRoute path="/user/:id" exact component={User} />
        <PrivateRoute path="/change-password" exact component={ChangePassword} />
        <PrivateRoute path="/delete-user" exact component={DeleteUser} />
        <Route component={Landing} />
      </Switch>
    </div>
  );
};

function App() {
  return (
    <>
      <Router>
        <Switch>
          <LoginRoute path="/login" exact component={Login} />
          <LoginRoute path="/forgot" exact component={ForgotPassword} />
          <Route component={Routes} />
        </Switch>
      </Router>
      <Footer />
    </>
  );
}

export default App;
